import React from 'react';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopLeaveSectionProps {
  registrationState: 'interest' | 'confirmed';
  onLeave: () => void;
  leaving?: boolean;
}

const WorkshopLeaveSection: React.FC<WorkshopLeaveSectionProps> = ({
  registrationState,
  onLeave,
  leaving = false,
}) => {
  const isConfirmed = registrationState === 'confirmed';

  return (
    <section id="leave-workshop" className={styles.leaveWorkshopSection}>
      <h3 className={styles.leaveWorkshopTitle}>Leave the workshop</h3>
      <p className={styles.leaveWorkshopText}>
        {isConfirmed
          ? 'You can leave anytime. Your name will be removed from the participant roster and contact lists. Leaving only affects your workshop membership — your step work in Recovery Commons stays with you. You can rejoin later if your plans change.'
          : 'You can leave the interest list anytime and stop workshop emails. You can rejoin later if your plans change.'}
      </p>
      <button type="button" className={styles.leaveWorkshopBtn} onClick={onLeave} disabled={leaving}>
        {leaving
          ? 'Removing…'
          : isConfirmed
            ? 'Leave the 2026 SAA Workshop'
            : 'Leave the interest list'}
      </button>
    </section>
  );
};

export default WorkshopLeaveSection;
